import { AsEditorEnum } from '@/types/enum';

export const resolveEditor = (editor: string) => {
  switch (editor) {
    case AsEditorEnum.DatePicker:
      return () => import('@/components/Ui/AsDatePicker.vue');
     
    case AsEditorEnum.CompanyNumber:
      return () => import('@/components/Inputs/CompanyNumberInput.vue');

    case AsEditorEnum.Checkbox:
      return () => import('@/components/Ui/AsCheckbox.vue');

    case AsEditorEnum.Select:
      return () => import('@/components/Ui/AsSelect.vue');

    case AsEditorEnum.File:
      return () => import('@/components/Ui/AsFileInput.vue');

    case AsEditorEnum.PDF:
      return () => import('@/components/Ui/AsPdfInput.vue');

    case AsEditorEnum.Radio:
      return () => import('@/components/Ui/AsRadioInput.vue');

    default: {
      return () => import('@/components/Ui/AsInput.vue');
    }
  }
};
